import script from "./create.vue?vue&type=script&setup=true&lang=js"
export * from "./create.vue?vue&type=script&setup=true&lang=js"

import "./create.vue?vue&type=style&index=0&id=34686736&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34686736"]])

export default __exports__